module.exports = __webpack_public_path__ + "static/media/consulting_about_14.a43bc78c.webp";